var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCap2025PayoffRgbBlu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 40,
    viewBox: "0 0 178 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1733 8.73124C33.7687 2.70824 29.6686 0.160314 20.988 0.160314C8.80427 0.160314 0 8.38208 0 19.961C0 31.5398 8.80427 39.764 20.988 39.764C29.495 39.764 35.3336 36.8716 39.0794 29.7539L34.613 26.6233C32.0207 31.3134 29.0075 34.6728 22.1914 34.6728C13.9912 34.6728 11.9483 26.4487 11.9483 19.7345C11.9483 13.0202 13.9936 4.68523 22.1914 4.68523C28.1632 4.68523 30.4535 8.21457 33.5285 12.0954L38.1733 8.7336V8.73124Z",
    fill: "#274272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9489 39.9621L48.9967 28.3691H62.9974L67.5589 39.9621H80.5227L64.988 0.00460779H53.2989L38.9129 39.9621H44.9489ZM55.6724 9.07096H55.8056L61.1305 22.9477H50.923L55.6724 9.07096Z",
    fill: "#274272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0562 18.3827V5.43545H98.6545C103.021 5.43545 105.723 7.95978 105.723 12.2158C105.723 15.9739 103.532 18.3827 99.104 18.3827H95.0562ZM95.0562 39.9621V23.8088H104.298C110.983 23.8088 117.79 21.0934 117.79 12.8905C117.79 4.68759 111.3 0.00460779 102.441 0.00460779H83.3719V39.9621H95.0562Z",
    fill: "#274272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.093 0.117959L136.071 0.0707756H135.486L135.465 0.117959L132.314 6.87939L132.262 6.99263H132.961L132.982 6.94544L133.822 5.11236H137.71L138.55 6.94544L138.571 6.99263H139.299L139.246 6.87939L136.095 0.117959H136.093ZM134.105 4.50369L135.767 0.891772L137.422 4.50369H134.105Z",
    fill: "url(#paint0_linear_12704_5753)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.46 5.47567L146.403 5.42141L146.346 5.47567C145.603 6.2023 144.945 6.4972 144.072 6.4972C142.512 6.4972 141.289 5.20436 141.289 3.55529V3.53642C141.289 1.87083 142.481 0.613388 144.06 0.613388C145.135 0.613388 145.789 1.10174 146.286 1.5783L146.343 1.63256L146.398 1.57594L146.755 1.21026L146.812 1.15128L146.75 1.09466C146.027 0.436449 145.294 0 144.065 0C142.122 0 140.6 1.55942 140.6 3.55057V3.56945C140.6 5.58419 142.081 7.10115 144.043 7.10115C145.387 7.10115 146.184 6.4972 146.788 5.9074L146.847 5.85078L146.788 5.79416L146.45 5.46859L146.46 5.47567Z",
    fill: "url(#paint1_linear_12704_5753)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.434 5.91684C154.986 5.27278 155.29 4.43763 155.29 3.55765V3.53878C155.29 1.52403 153.797 0.00707756 151.815 0.00707756C149.63 0.00707756 148.322 1.81185 148.322 3.55765V3.57653C148.322 5.59127 149.815 7.10823 151.796 7.10823C152.617 7.10823 153.366 6.85108 153.97 6.36744L154.876 7.17428L154.936 7.22619L154.99 7.16957L155.347 6.78502L155.404 6.72368L155.34 6.66942L154.436 5.91684H154.434ZM153.946 5.49454L152.712 4.38101L152.653 4.32675L152.598 4.38573L152.241 4.77971L152.186 4.84105L152.248 4.89531L153.49 5.94515C153.021 6.30846 152.443 6.49956 151.818 6.49956C150.241 6.49956 149.007 5.20672 149.007 3.55765V3.53878C149.007 1.87319 150.208 0.615748 151.799 0.615748C153.39 0.615748 154.61 1.90858 154.61 3.55765V3.57653C154.61 4.3008 154.374 4.97788 153.949 5.49454H153.946Z",
    fill: "url(#paint2_linear_12704_5753)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.634 0.120318H162.553V4.1215C162.553 5.6243 161.761 6.48776 160.382 6.48776C159.003 6.48776 158.17 5.60779 158.17 4.07431V0.120318H157.507V4.1215C157.507 5.95694 158.601 7.09879 160.361 7.09879C162.12 7.09879 163.214 5.93571 163.214 4.06488V0.120318H162.632H162.634Z",
    fill: "url(#paint3_linear_12704_5753)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.701 0.117959L168.68 0.0707756H168.095L168.073 0.117959L164.922 6.87939L164.87 6.99263H165.569L165.59 6.94544L166.43 5.11236H170.318L171.158 6.94544L171.179 6.99263H171.907L171.855 6.87939L168.703 0.117959H168.701ZM166.713 4.50369L168.375 0.891772L170.03 4.50369H166.713Z",
    fill: "url(#paint4_linear_12704_5753)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.11 16.519L138.053 16.4648L137.995 16.519C137.253 17.2457 136.595 17.5405 135.722 17.5405C134.162 17.5405 132.939 16.2477 132.939 14.5986V14.5798C132.939 12.9142 134.131 11.6567 135.71 11.6567C136.785 11.6567 137.439 12.1451 137.936 12.6216L137.993 12.6759L138.048 12.6193L138.405 12.2536L138.462 12.1946L138.4 12.138C137.677 11.4798 136.944 11.0433 135.715 11.0433C133.772 11.0433 132.25 12.6028 132.25 14.5939V14.6128C132.25 16.6275 133.731 18.1445 135.693 18.1445C137.037 18.1445 137.834 17.5405 138.438 16.9508L138.497 16.8941L138.438 16.8375L138.1 16.5119L138.11 16.519Z",
    fill: "url(#paint5_linear_12704_5753)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M145.301 11.1637V14.2707H141.13V11.1637H140.466V18.036H141.13V14.8912H145.301V18.036H145.965V11.1637H145.301Z",
    fill: "url(#paint6_linear_12704_5753)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M149.249 17.4155V14.8817H153.128V14.2613H149.249V11.7841H153.563V11.1637H148.588V18.036H153.611V17.4155H149.249Z",
    fill: "url(#paint7_linear_12704_5753)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.655 25.3211H135.574V25.9416H137.836V27.7511C137.399 28.105 136.633 28.4754 135.76 28.4754C134.074 28.4754 132.939 27.2887 132.939 25.524V25.5052C132.939 23.8655 134.131 22.5821 135.653 22.5821C136.723 22.5821 137.327 22.9785 137.774 23.3677L137.834 23.4196L137.886 23.3607L138.214 22.9879L138.269 22.9266L138.205 22.8747C137.427 22.2353 136.695 21.9735 135.679 21.9735C133.534 21.9735 132.254 23.7782 132.254 25.524V25.5429C132.254 27.6237 133.686 29.0746 135.739 29.0746C137.135 29.0746 138.1 28.3574 138.45 28.0484L138.476 28.0248V25.3188H135.651L135.655 25.3211Z",
    fill: "url(#paint8_linear_12704_5753)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.575 28.3409V25.8071H145.451V25.1867H141.575V22.7095H145.887V22.0891H140.911V28.9614H145.934V28.3409H141.575Z",
    fill: "url(#paint9_linear_12704_5753)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M153.304 22.0891V27.7794L148.778 22.1197L148.755 22.0891H148.162V28.9614H148.805V23.146L153.428 28.9307L153.454 28.9614H153.949V22.0891H153.304Z",
    fill: "url(#paint10_linear_12704_5753)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.236 28.3409V25.8071H161.112V25.1867H157.236V22.7095H161.547V22.0891H156.572V28.9614H161.595V28.3409H157.236Z",
    fill: "url(#paint11_linear_12704_5753)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.326 26.0714C168.53 25.8661 169.243 25.1348 169.243 24.0944V24.0755C169.243 23.5848 169.048 23.1106 168.708 22.7732C168.263 22.3321 167.567 22.0891 166.746 22.0891H163.823V28.9614H164.487V26.1799H166.582L168.737 28.9614H169.579L169.479 28.834L167.329 26.0737L167.326 26.0714ZM164.487 25.5689V22.7072H166.718C167.883 22.7072 168.58 23.2262 168.58 24.0944V24.1132C168.58 24.9979 167.838 25.5689 166.689 25.5689H164.487Z",
    fill: "url(#paint12_linear_12704_5753)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M174.794 22.0867L174.773 22.0395H174.188L174.166 22.0867L171.015 28.8481L170.963 28.9614H171.662L171.683 28.9142L172.523 27.0811H176.411L177.251 28.9142L177.272 28.9614H178L177.948 28.8481L174.796 22.0867H174.794ZM172.806 26.4724L174.468 22.8605L176.124 26.4724H172.806Z",
    fill: "url(#paint13_linear_12704_5753)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.259 33.0144V39.8868H132.923V36.8458H136.752V36.2253H132.923V33.6326H137.187V33.0144H132.259Z",
    fill: "url(#paint14_linear_12704_5753)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.314 33.0144V37.0156C144.314 38.5184 143.523 39.3819 142.143 39.3819C140.764 39.3819 139.931 38.5019 139.931 36.9684V33.0144H139.268V37.0156C139.268 38.8511 140.362 39.9929 142.122 39.9929C143.882 39.9929 144.978 38.8298 144.978 36.959V33.0144H144.314Z",
    fill: "url(#paint15_linear_12704_5753)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.011 33.0144V33.6326H149.371V39.8868H150.034V33.6326H152.393V33.0144H147.011Z",
    fill: "url(#paint16_linear_12704_5753)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M159.473 33.0144V37.0156C159.473 38.5184 158.681 39.3819 157.302 39.3819C155.923 39.3819 155.09 38.5019 155.09 36.9684V33.0144H154.427V37.0156C154.427 38.8511 155.521 39.9929 157.283 39.9929C159.045 39.9929 160.137 38.8298 160.137 36.959V33.0144H159.473Z",
    fill: "url(#paint17_linear_12704_5753)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M166.156 36.9968C167.36 36.7915 168.073 36.0602 168.073 35.0198V35.0009C168.073 34.5102 167.878 34.036 167.538 33.6986C167.093 33.2574 166.397 33.0144 165.576 33.0144H162.653V39.8868H163.317V37.1053H165.412L167.567 39.8868H168.409L168.309 39.7594L166.159 36.9991L166.156 36.9968ZM163.317 36.4942V33.6326H165.547C166.713 33.6326 167.41 34.1516 167.41 35.0198V35.0386C167.41 35.9233 166.668 36.4942 165.519 36.4942H163.317Z",
    fill: "url(#paint18_linear_12704_5753)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M173.61 32.8988C171.424 32.8988 170.116 34.7036 170.116 36.4494V36.4683C170.116 38.483 171.61 40 173.591 40C175.776 40 177.084 38.1952 177.084 36.4494V36.4305C177.084 34.4158 175.591 32.8988 173.61 32.8988ZM176.399 36.4683C176.399 38.1339 175.201 39.3913 173.61 39.3913C172.019 39.3913 170.799 38.0985 170.799 36.4494V36.4305C170.799 34.765 172 33.5075 173.591 33.5075C175.182 33.5075 176.402 34.8004 176.402 36.4494V36.4683H176.399Z",
    fill: "url(#paint19_linear_12704_5753)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M127.579 0.00460779H127.103V39.9055H127.579V0.00460779Z",
    fill: "url(#paint20_linear_12704_5753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12704_5753",
    x1: 88.9699,
    y1: -74.4649,
    x2: 88.9699,
    y2: 295.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12704_5753",
    x1: 89.2371,
    y1: -72.1861,
    x2: 89.2371,
    y2: 288.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12704_5753",
    x1: 89,
    y1: -71.0458,
    x2: 89,
    y2: 283.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12704_5753",
    x1: 89.0742,
    y1: -74.1447,
    x2: 89.0742,
    y2: 292.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12704_5753",
    x1: 88.9699,
    y1: -74.4649,
    x2: 88.9699,
    y2: 295.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12704_5753",
    x1: 89.2371,
    y1: -134.392,
    x2: 89.2371,
    y2: 225.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12704_5753",
    x1: 89,
    y1: -139.567,
    x2: 89,
    y2: 232.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12704_5753",
    x1: 89,
    y1: -139.567,
    x2: 89,
    y2: 232.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12704_5753",
    x1: 89.1361,
    y1: -195.96,
    x2: 89.1361,
    y2: 164.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12704_5753",
    x1: 89,
    y1: -203.158,
    x2: 89,
    y2: 169.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12704_5753",
    x1: 88.9634,
    y1: -203.158,
    x2: 88.9634,
    y2: 169.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12704_5753",
    x1: 89,
    y1: -203.158,
    x2: 89,
    y2: 169.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12704_5753",
    x1: 89.0001,
    y1: -203.158,
    x2: 89.0001,
    y2: 169.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12704_5753",
    x1: 88.9699,
    y1: -201.418,
    x2: 88.9699,
    y2: 168.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12704_5753",
    x1: 89,
    y1: -266.749,
    x2: 89,
    y2: 105.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12704_5753",
    x1: 89.0371,
    y1: -262.691,
    x2: 89.0371,
    y2: 104.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12704_5753",
    x1: 88.9607,
    y1: -266.749,
    x2: 88.9607,
    y2: 105.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12704_5753",
    x1: 88.9629,
    y1: -262.691,
    x2: 88.9629,
    y2: 104.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12704_5753",
    x1: 89,
    y1: -192.132,
    x2: 89,
    y2: 105.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12704_5753",
    x1: 89,
    y1: -257.502,
    x2: 89,
    y2: 102.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_12704_5753",
    x1: 127.341,
    y1: 0.00460779,
    x2: 127.341,
    y2: 39.9055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#274272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#254475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#155E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0970B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#027BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap2025PayoffRgbBlu);
export default __webpack_public_path__ + "static/media/CAP_2025_Payoff_RGB_Blu.a1b059c61a6b96b5cf0a7d41d4600ae2.svg";
export { ForwardRef as ReactComponent };